import React, { Fragment, useState } from 'react';
import { IMemberInfo, MEMBER_TYPE, SWITCH_STATUS } from '../../interface';
import { components } from 'common';
import { defaultPageInfo } from '../../service/defaultData/knowledgePoint';
import { lang } from '@umu/ukit-lang';
import { Checkbox } from '@umu/umu-design';
import { classSet } from '@umu/umu-dom';
import { COLOR_MAP } from '../../utils';
import { IPageInfo } from '@umu/umu-types';
import './index.scss';
import { UserAvatar } from '../../../user';
import { getAvatarWord } from '../../../@loadAvatar/loadAvatar';
import InfiniteScroll from '../../../@infiniteScroll/infiniteScroll';
import ListBlankM from '../../../ListBlank/ListBlankM';
import { RadioBox } from '../radio';

interface IProps {
    pageInfo?: IPageInfo;
    list: IMemberInfo[];
    loading?: boolean;
    searchValue?: string;
    selectList?: IMemberInfo[];
    isMultiple?: boolean;
    getListByPage?: (page: number) => void;
    onItemClick: (item: IMemberInfo) => void;
}
const { List, ListBlank, ListLoading, If } = components;
const getContent = (name: string, searchKey: string): JSX.Element | string => {
    const index = name.indexOf(searchKey);
    if (searchKey === '' || index === -1) {
        return name;
    }
    const list = name.split(searchKey);
    const ele = list.map((str, index) => {
        const isLast = index === list.length - 1;
        const suffix = isLast ? '' : <em className="search-key">{searchKey}</em>;
        return (
            <Fragment key={`str-${index}`}>
                {str}
                {suffix}
            </Fragment>
        );
    });
    return <span>{ele}</span>;
};
function SearchMemberList(props: IProps) {
    const {
        list,
        pageInfo = defaultPageInfo,
        selectList = [],
        searchValue = '',
        loading,
        isMultiple = false,
        getListByPage,
        onItemClick,
    } = props;
    const [isLoading, setIsLoading] = useState(false);
    const onLoadMore = async () => {
        if (pageInfo.total_page_num <= pageInfo.current_page || isLoading) {
            return;
        }
        setIsLoading(true);
        getListByPage && getListByPage(pageInfo.current_page + 1);
    };

    const renderListItem = (item: IMemberInfo) => {
        const isDepartment = item.type === MEMBER_TYPE.DEPARTMENT;
        const isCheck = selectList.some((selectItem) => selectItem.id === item.id);
        let showLabel = item.name || item.login_name || item.email || item.phone;

        if (isDepartment && item.path && item.path?.length > 0) {
            const prefix = item.path.map((pathItem) => pathItem.name).join('/');
            showLabel = `${prefix}  /  ${showLabel}`;
        }
        const random = Number(item.id) || Math.floor(Math.random() * COLOR_MAP.length);
        const isDepartmentManage = Number(item.is_department_manager) === SWITCH_STATUS.YES;
        const isNotAllowCheck = Object(item).hasOwnProperty('is_manage') && item.is_manage === SWITCH_STATUS.NO;

        const content = (
            <div className="member-item-label">
                <If condition={!isDepartment}>
                    {item.avatar ? (
                        <UserAvatar className="avatar-component split-col" src={item.avatar || ''} width={20} />
                    ) : (
                        <div
                            className="department-search-avatar-label split-col"
                            style={{ backgroundColor: COLOR_MAP[random] }}
                        >
                            {getAvatarWord(showLabel)}
                        </div>
                    )}
                </If>
                <span className="item-info-label">{getContent(showLabel, searchValue)}</span>
                <If condition={isDepartmentManage && !isDepartment}>
                    <span className="manage-department-label">{lang('负责人')}</span>
                </If>
                <If condition={isDepartment}>
                    <span className="static-count">{` (${item.user_num})`}</span>
                </If>
            </div>
        );

        return (
            <div
                key={`member-item-${item.id}`}
                className={classSet({
                    'member-result-item': true,
                    'member-result-item-no-event': isNotAllowCheck,
                })}
                onClick={() => !isNotAllowCheck && onItemClick(item)}
            >
                <If condition={isMultiple}>
                    <Checkbox>{content}</Checkbox>
                </If>
                <If condition={!isMultiple}>
                    <>
                        <RadioBox checked={isCheck} disabled={isNotAllowCheck} />
                        {content}
                    </>
                </If>
            </div>
        );
    };
    return (
        <InfiniteScroll
            load={onLoadMore}
            hasMore={pageInfo.total_page_num > pageInfo.current_page}
            isLoading={!loading}
            bottomDistance={70}
            scrollThreshold={500}
            isLoadedData={isLoading}
        >
            <List
                dataList={list}
                className="member-result-list-info"
                totalPageNum={1}
                currentPage={1}
                renderItem={renderListItem}
            >
                <ListBlank>
                    <ListBlankM className="member-search-result-empty" title={lang('暂无搜索结果')} type={5} />
                </ListBlank>
                <ListLoading />
            </List>
        </InfiniteScroll>
    );
}

export default SearchMemberList;
